import axios from 'axios'

export const SUBMIT_CONTACT_INFOS = 'SUBMIT_CONTACT_INFOS'

function fetchForIP() {
  return axios
    .get('https://pc.cloud.pm2.io/info')
    .then(response => response.data, () => ({ restricted: false }))
}

function fetchForCountry(country) {
  return axios
    .get(`https://pc.cloud.pm2.io/info/${country}`)
    .then(response => response.data, () => ({ restricted: false }))
}

async function getPricingControl(getters) {
  // fetch his cards
  const cards = await getters.currentBillingCards
  if (cards.length === 0) {
    // use his IP if he don't have a card
    return fetchForIP()
  }

  // check the country code for each cards
  const results = await Promise.all(cards.map(card => fetchForCountry(card.country)))

  // if any card has a blacklisted country, blacklist him
  return results.find(result => result.restricted === true) || { restricted: false }
}

function getForcedPricingControl(user) {
  if (window.RESTRICTED_PRICING !== undefined) {
    return { restricted: Boolean(window.RESTRICTED_PRICING) }
  }

  if (document.location.search.includes('no-restricted-pricing')) {
    return { restricted: false }
  }

  if (document.location.search.includes('force-restricted-pricing')) {
    return { restricted: true }
  }

  if (user.role === 'admin') {
    return { restricted: false }
  }

  return false
}

const actions = {
  [SUBMIT_CONTACT_INFOS]({ state, getters }, { email, fullname, phone, processes, comments }) {
    axios
      .post('https://pm2automationemgnzyhn-cohorts.functions.fnc.fr-par.scw.cloud', {
        email,
        fullname,
        phone,
        processes,
        comments,
        user: getters.backofficeURLs.user,
        bucket: getters.backofficeURLs.bucket,
        source: 'app-frontend'
      })
      .then(res => res.data)


    return axios
      .post('https://pc.cloud.pm2.io/contact', {
        email,
        fullname,
        phone,
        processes,
        comments,
        user: getters.backofficeURLs.user,
        bucket: getters.backofficeURLs.bucket,
      })
      .then(res => res.data)
  },
}

export default {
  actions,
  getters: {
    pricingControl(state, getters) {
      const forcedPricingControl = getForcedPricingControl(getters.user)
      if (forcedPricingControl) return Promise.resolve(forcedPricingControl)

      return getPricingControl(getters)
    },
  },
}
